import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from '@mui/material';
import { useDispatch } from 'react-redux';

import { deleteChild } from '../../thunk';

import type { ChildJson } from '@/types/domain/child/entities/childEntity';

import DialogTitle from '@/components/DialogTitle';
import DialogTransition from '@/components/DialogTransition';
import { toStringDateDisplay } from '@/utils/date';

/**
 * プロパティ
 */
export type Props = {
  /** 子ども */
  child: ChildJson,
  /** 開く */
  setIsOpen: (isOpen: boolean) => void,
};

const Delete: React.FC<Props> = ({ child, setIsOpen }) => {
  const dispatch = useDispatch();
  const {
    name,
    nameKana,
    familyName,
    familyNameKana,
    gender,
    birthday,
  } = child;
  return (
    <Dialog
      open
      onClose={() => setIsOpen(false)}
      fullScreen
      TransitionComponent={DialogTransition}
    >
      <DialogTitle title="子どもを登録から外しますか？" />
      <DialogContent>
        <p>
          {`名前：${familyName.toString()} ${name.toString()} (${familyNameKana.toString()} ${nameKana.toString()})`}
        </p>
        <p>
          {`性別：${gender.toString()}`}
        </p>
        <p>
          {`誕生日：${toStringDateDisplay(new Date(birthday), false)}`}
        </p>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            dispatch(deleteChild(child));
            setIsOpen(false);
          }}
        >
          登録から外す
        </Button>
        <Button variant="contained" color="primary" onClick={() => setIsOpen(false)}>
          閉じる
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Delete;
